<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          :alt="'Image ' + (index + 1)"
          class="collage-image"
          ref="collageImgs"
        >
      </div>
    </div>

    <!-- Modal -->
    <div v-if="isImageEnlarged" class="image-modal" @click="closeModal">
      <img :src="images[currentIndex]" class="enlarged-image">
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: 'CollageCarousel',
  data() {
    return {
      currentIndex: 0,
      isImageEnlarged: false,
      images: [
      ],
      itemTimelines: [],
      io: null,
      animatedOnce: [] // <- NUEVO: para marcar cuáles ya se animaron
    }
  },

  mounted() {
    this.initObserver()
  },

  beforeUnmount() {
    if (this.io) this.io.disconnect()
    this.itemTimelines.forEach(tl => tl && tl.kill())
  },

  methods: {
    nextSlide() { this.currentIndex = (this.currentIndex + 1) % this.images.length },
    prevSlide() { this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length },
    enlargeImage(index) { this.currentIndex = index; this.isImageEnlarged = true },
    closeModal() { this.isImageEnlarged = false },

    /* ---------- Animación con GSAP + IO ---------- */
    initObserver() {
      // marcar como no-animados al inicio
      this.animatedOnce = this.images.map(() => false)

      // estado inicial
      this.$refs.collageItems?.forEach((el, i) => {
        const img = this.$refs.collageImgs?.[i]
        gsap.set(el, {
          opacity: 0, y: 40, scale: 0.98,
          filter: 'blur(6px)', boxShadow: '0 0 0 rgba(0,0,0,0)',
        })
        gsap.set(img, { transformOrigin: '50% 55%', rotate: 0.2 })
      })

      const options = { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.35 }
      this.io = new IntersectionObserver(this.handleIntersection, options)
      this.$refs.collageItems?.forEach(item => this.io.observe(item))
    },

    handleIntersection(entries) {
      entries.forEach(entry => {
        const index = this.$refs.collageItems.indexOf(entry.target)
        if (index === -1) return

        // Si ya se animó una vez, no hacemos nada (se queda visible)
        if (this.animatedOnce[index]) return

        if (entry.isIntersecting) {
          if (this.itemTimelines[index]) this.itemTimelines[index].kill()

          const el  = this.$refs.collageItems[index]
          const img = this.$refs.collageImgs[index]

          const tl = gsap.timeline()
            .to(el, {
              opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
              boxShadow: '0 18px 40px rgba(0,0,0,.12)',
              duration: 0.9, ease: 'power3.out'
            })
            .fromTo(img,
              { y: 12, scale: 1.02, rotate: 0.2 },
              { y: 0,  scale: 1,    rotate: 0, duration: 0.9, ease: 'power2.out' },
              '-=0.75'
            )
            .fromTo(img,
              { clipPath: 'inset(0 0 100% 0 round 8px)' },
              { clipPath: 'inset(0 0 0% 0 round 8px)', duration: 0.9, ease: 'power3.out' },
              '-=0.75'
            )

          this.itemTimelines[index] = tl
          this.animatedOnce[index] = true     // <- marcar como animado
          this.io.unobserve(entry.target)     // <- dejar de observar: NO se revertirá
        }

        // IMPORTANTE: quitamos el "else" que revertía al salir del viewport
      })
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  max-width: 1000px;
    background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  margin: 0 auto;
  overflow: hidden;
}

.collage-grid {
  display: block;
  width: 100%;
}

.collage-item {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
  background: #fff;
  margin: 0 0 18px 0;
  will-change: transform, opacity, filter, box-shadow, clip-path;
  transition: transform .25s ease;
}
.collage-item:hover { transform: translateY(-2px); }

.collage-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
}

.image-modal {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.6);
  display: grid; place-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}
.enlarged-image {
  max-width: 86vw; max-height: 86vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 18px 60px rgba(0,0,0,.35);
}
</style>
